import { createContext, useContext, type ReactNode } from 'react';
import type { MapViewProps } from './MapView';

/**
 * A real map implementation (MapLibre, Leaflet…) plugs in here. `MapView` renders `provider.render(props)`
 * when a provider is in scope and falls back to the static route summary otherwise (D-006).
 */
export interface MapProvider {
  /** Short name for diagnostics (`maplibre`). */
  name: string;
  render: (props: MapViewProps) => ReactNode;
}

const MapProviderContext = createContext<MapProvider | null>(null);

export function MapProviderProvider({ provider, children }: { provider: MapProvider | null; children: ReactNode }) {
  return <MapProviderContext.Provider value={provider}>{children}</MapProviderContext.Provider>;
}

export function useMapProvider(): MapProvider | null {
  return useContext(MapProviderContext);
}
